import * as React from 'react'
import { Link } from 'react-router-dom'
import Dropdown from 'ui/atoms/Dropdown'

function NavBarDropdownItem({ path, children }) {
  return (
    <Link
      className={`
          block
          w-full
          text-center
          px-4
          py-2
          text-sm
          no-underline
          hover:no-underline
          hover:text-zentake
          leading-5
          text-gray-500
          hover:bg-gray-100
          focus:outline-none
          transition
          duration-150
          ease-in-out
        `}
      to={path}
    >
      {children}
    </Link>
  )
}

function NavBarDropdown({ children }) {
  const items = React.useMemo(() => {
    return [
      {
        key: 'exports',
        label: (
          <NavBarDropdownItem path="/exports">CSV Export</NavBarDropdownItem>
        ),
      },
      {
        key: 'reports',
        label: <NavBarDropdownItem path="/reports">Reports</NavBarDropdownItem>,
      },
    ]
  }, [])

  return (
    <Dropdown
      className="mr-8 inline-flex relative items-center px-1 pt-1 text-sm font-medium leading-5 text-gray-500 no-underline hover:no-underline hover:text-gray-500 hover:border-gray-300 border-b-2 border-transparent transition duration-150 ease-in-out cursor-pointer"
      items={items}
    >
      {children}
    </Dropdown>
  )
}

export default NavBarDropdown
